/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class RubricsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      templateSets: this.store.findAll('milestones/set'),
      milestones: this.store.findAll('milestones/milestone'),
      subjects: this.store.findAll('goals/subject'),
    });
  }
}
